// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","primary":"#005d60","primaryHover":"#004042","primaryActive":"#004042","intoRed":"#e2001a","copyColor":"#a6a6a6"};